import React, { useState, useEffect, useContext, useRef } from "react"; /*st48236 - 508 compliance*/
import 'bootstrap/dist/css/bootstrap.min.css';
import { styled } from '@mui/material/styles';
import { Tab, Tabs, Spinner } from "react-bootstrap";
import './notification.css';
import Switch from '@mui/material/Switch';
import "react-datepicker/dist/react-datepicker.css";
import '../../assets/css/Style.css';
import { getApiService } from "../../services/ApiService";
import { GetPayLoad } from "../../services/PayLoadStorage";
import { LanguageContext } from "../../contexts/LanguageContext";
import MemberPreference from "../../components/MemberPreference";
import Cookies from "js-cookie";

const Settings = () => {
    const [key, setKey] = useState('case-info');
    const [caseInfo, setCaseInfo] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [errorFlag, setErrorFlag] = useState(false);

    const Payload = GetPayLoad('PayLoad');
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    
    const { pageContent } = useContext(LanguageContext);
    const [settingsContent, setSettingsContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const ref = useRef(null); //st48236 - 508 compliance
    const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
    const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed

    // Set icons based on owning carrier
    let owningCarrier = Payload?.owning_carrier || '';
    const connectiCareCarrier = Cookies.get("connectiCareCarrier") || null;
    const isConnectiCareCarrier = Cookies.get("isConnectiCareCarrier") || 'false';
    const [accountCarrierIcon, setAccountCarrierIcon] = useState(null);

    useEffect(() => {
        // When ConnectiCare carrier is set, override owningCarrier
        owningCarrier = ( isConnectiCareCarrier === 'true' && connectiCareCarrier !== null && connectiCareCarrier !== undefined) ? connectiCareCarrier : owningCarrier;
        import("../../assets/images/Illustrations/Account-Carrier-"+owningCarrier+".svg").then((image) => {
            setAccountCarrierIcon(image.default);
        }).catch((error) => {
            import("../../assets/images/Illustrations/Account-Carrier.svg").then((image) => {
                setAccountCarrierIcon(image.default);
            });
        });

    }, [owningCarrier, connectiCareCarrier]);

    useEffect(() => {

        if (pageContent?.settings) {
            setSettingsContent(pageContent.settings);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
    }, [pageContent]);
    
    // Fetch case info from API
    const fetchCaseInfo = async () => {
        setLoading(true);
        setErrorFlag(false);
        try {
            const headers = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier
            };
            const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
            const response = await getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim, apiSource: 'settings' }, headers);
             if (response?.data?.statusCode === 200) {
                setCaseInfo(response?.data?.data);
            } else {
                setErrorFlag(true);
            } 
        } catch (error) {
            setErrorFlag(true);
        } finally {
            setLoading(false);
            setApiCallsCompleted(true); // st48236 - 508 compliance Mark API call as completed
        }
    };
    // Fetch case info on component mount
    useEffect(() => {
        fetchCaseInfo();
    }, []);

    const AntSwitch = styled(Switch)(({ theme }) => ({
        width: 32,
        height: 16,
        padding: 0,
        display: 'flex',
        '&:active': {
            '& .MuiSwitch-thumb': {
                width: 15,
            },
            '& .MuiSwitch-switchBase.Mui-checked': {
                transform: 'translateX(12px)',
            },
        },
        '& .MuiSwitch-switchBase': {
            padding: 2,
            '&.Mui-checked': {
                transform: 'translateX(15px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: '#1890ff',
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#177ddc',
                    }),
                },
            },
        },
        '& .MuiSwitch-thumb': {
            boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
            width: 12,
            height: 12,
            borderRadius: 6,
            transition: theme.transitions.create(['width'], {
                duration: 200,
            }),
        },
        '& .MuiSwitch-track': {
            borderRadius: 16 / 2,
            opacity: 1,
            backgroundColor: 'rgba(0,0,0,.25)',
            boxSizing: 'border-box',
            ...theme.applyStyles('dark', {
                backgroundColor: 'rgba(255,255,255,.35)',
            }),
        },
    }));

    /*st48236 - 508 compliance*/      
    // Mark content as ready
    const [userInteracted, setUserInteracted] = useState(false);
        
        useEffect(() => {
          const handleUserInteraction = () => {
            setUserInteracted(true);
          };
        
          // Listen for user interactions
          document.addEventListener('click', handleUserInteraction);
          document.addEventListener('keydown', handleUserInteraction);
          
          return () => {
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
          };
        }, []);
        
        useEffect(() => {
          let timeoutId;
          
          if (apiCallsCompleted && !isContentReady) {
            timeoutId = setTimeout(() => {
              setContentReady(true);
              
              // Only auto-focus if user hasn't interacted
              if (!userInteracted && ref.current) {
                requestAnimationFrame(() => {
                  ref.current.focus({ preventScroll: true });
                });
              }
            }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
          }
          
          return () => {
            if (timeoutId) clearTimeout(timeoutId);
          };
        }, [apiCallsCompleted, isContentReady, userInteracted]);
    
    /*st48236 - 508 compliance*/

    return (
        <>
        <main
            role="main"
            tabIndex="-1" // Make the <main> tag focusable
            ref={ref} // Attach the ref to the <main> tag
            aria-label="Account Settings"
            style={{ outline: 'none' }} // revmove border
        > {/*st48236 - 508 compliance*/}   
            <div>
                <div className="conatiner-fluid content-inner mt-n5 py-0">
                    <div className="col-md-12 col-xl-12">
                        <div className="card" data-aos="fade-up" data-aos-delay="800">
                            <div className="col-md-12 card-body settings-body">
                                <Tabs
                                    id="controlled-tab-example"
                                    activeKey={key}
                                    onSelect={(k) => setKey(k)}
                                    className="mb-3"
                                    {...(Payload?.owning_carrier === 'Q5' ? {style: {"--bs-nav-tabs-border-width": "0px"}} : {})}
                                >
                                    <Tab eventKey="case-info" {...(Payload?.owning_carrier !== 'Q5' ? { title: settingsContent?.settings_account_title } : {})}>
                                        {errorFlag && (
                                            <div tabIndex={0} className="api-error-msg">
                                                {genericContent?.case_info_service_error}
                                            </div>
                                        )}
                                        
                                        {isLoading && (
                                            <div tabIndex={0} style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                                                <Spinner animation="border" role="status" ></Spinner>
                                                <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                            </div>
                                        )}

                                            {!isLoading && !errorFlag && caseInfo && (
                                                <div className="tab-content tab-border mt-4 tabcontentrounded-4 card-body settings-tabcontent" id="nav-tabContent">
                                                    <div className="tab-pane fade show active" id="nav-home" role="tabpanel">
                                                        <div className="col-xl-12 d-xl-flex d-md-flex d-sm-flex d-block mb-5 align-items-start">
                                                            <div className={`col-xl-2 col-md-3 col-sm-3 me-2 col-12 mb-md-0${Payload?.owning_carrier === 'Q5' ? ' q5-avatar-col' : ''}`}>
                                                                <div className="align-items-center avatar-100">
                                                                    {caseInfo?.profileName}
                                                                </div>
                                                            </div>
                                                            <div tabIndex={0} className="col-xl-10 col-md-9 col-sm-9 col-12 mt-3 mt-md-0">
                                                                <h5>{caseInfo?.displayName}</h5>
                                                                <span className={`d-block mb-2 mt-2 ${Payload?.owning_carrier === 'Q5' ? 'spantextcolor' : ''}`}>{settingsContent?.settings_dob_text} {caseInfo?.DoB}</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-12 d-flex">
                                                            <div className="col-xl-12 d-flex">
                                                                {/* Conditional layout for BCBSAZ */}
                                                                {Payload?.owning_carrier === 'Q5' ? (
                                                                    <div className="col-12">
                                                                        <h5 tabIndex={0} className={`mb-3 fw-semibold${Payload?.owning_carrier === 'Q5' ? ' q5-personal-info-title' : ''}`}>
                                                                            {settingsContent?.settings_personal_info_title}
                                                                        </h5>

                                                                        <div className="col-xl-12 d-xl-flex d-md-flex d-block mb-3">
                                                                            <div tabIndex={0} className="col-xl-4 col-sm-4 col-12 labels">
                                                                                <label className="label-heading">
                                                                                    {settingsContent?.settings_email_address_text}
                                                                                </label>
                                                                                <label className="label-name fw-normal">
                                                                                    {caseInfo?.email}
                                                                                </label>
                                                                            </div>
                                                                            <div tabIndex={0} className="col-xl-4 col-sm-4 col-12 labels">
                                                                                <label className="label-heading">
                                                                                    {settingsContent?.settings_primary_phone_text}
                                                                                </label>
                                                                                <label className="label-name fw-normal">
                                                                                    {/* st48236 - INC0288091 - display secondary phone number - start */}
                                                                                    {caseInfo?.phoneNumber !== 'N/A'
                                                                                        ? caseInfo?.phoneTypeLabel && caseInfo?.phoneTypeLabel !== '' ? caseInfo?.phoneTypeLabel +" - "+caseInfo?.phoneNumber : caseInfo?.phoneNumber
                                                                                        : 'N/A'}
                                                                                </label>
                                                                            </div>
                                                                            <div tabIndex={0} className="col-xl-4 col-sm-4 col-12 labels">
                                                                                <label className="label-heading">
                                                                                    {settingsContent?.settings_secondary_phone_text}
                                                                                </label>
                                                                                <label className="label-name fw-normal">
                                                                                    {caseInfo?.secondaryphone !== 'N/A'
                                                                                        ? caseInfo?.secondaryPhoneTypeLabel && caseInfo?.secondaryPhoneTypeLabel !== '' ? caseInfo?.secondaryPhoneTypeLabel +" - "+caseInfo?.secondaryphone : caseInfo?.secondaryphone
                                                                                        : 'N/A'}
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-12 d-xl-flex d-md-flex d-block mb-3">
                                                                            <div tabIndex={0} className="col-xl-4 col-sm-4 col-12 labels">
                                                                                <label className="label-heading">
                                                                                    {settingsContent?.settings_mailing_address_text}
                                                                                </label>
                                                                                <label className="label-name fw-normal">
                                                                                    {caseInfo?.mailAddress}
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        {/* st48236 - INC0288091 - display secondary phone number - end */}
                                                                    </div>
                                                                ) : (
                                                                    // Default layout for Cigna, Molina, Christus, Mountain, etc.
                                                                    <>
                                                                        <div className="col-7">
                                                                            <h5 tabIndex={0} className="mb-3 fw-semibold">
                                                                                {settingsContent?.settings_personal_info_title}
                                                                            </h5>

                                                                            <div className="col-xl-12 d-xl-flex d-md-flex d-block mb-3">
                                                                                <div tabIndex={0} className="col-xl-6 col-sm-6 col-12 labels">
                                                                                    <label className="label-heading">
                                                                                        {settingsContent?.settings_email_address_text}
                                                                                    </label>
                                                                                    <label className="label-name fw-normal">
                                                                                        {caseInfo?.email}
                                                                                    </label>
                                                                                </div>
                                                                                <div tabIndex={0} className="col-xl-6 col-sm-6 col-12 labels">
                                                                                    <label className="label-heading">
                                                                                        {settingsContent?.settings_primary_phone_text}
                                                                                    </label>
                                                                                    <label className="label-name fw-normal">
                                                                                        {/* st48236 - INC0288091 - display secondary phone number - start */}
                                                                                        {caseInfo?.phoneNumber !== 'N/A'
                                                                                        ? caseInfo?.phoneTypeLabel && caseInfo?.phoneTypeLabel !== '' ? caseInfo?.phoneTypeLabel +" - "+caseInfo?.phoneNumber : caseInfo?.phoneNumber
                                                                                        : 'N/A'}
                                                                                    </label>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-xl-12 d-xl-flex d-md-flex d-block mb-3">
                                                                                <div tabIndex={0} className="col-xl-6 col-sm-6 col-12 labels">
                                                                                    <label className="label-heading">
                                                                                        {settingsContent?.settings_secondary_phone_text}
                                                                                    </label>
                                                                                    <label className="label-name fw-normal">
                                                                                        {caseInfo?.secondaryphone !== 'N/A'
                                                                                            ? caseInfo?.secondaryPhoneTypeLabel && caseInfo?.secondaryPhoneTypeLabel !== '' ? caseInfo?.secondaryPhoneTypeLabel +" - "+caseInfo?.secondaryphone : caseInfo?.secondaryphone
                                                                                            : 'N/A'}
                                                                                    </label>
                                                                                </div>
                                                                                {/* st48236 - INC0288091 - display secondary phone number - end */}            
                                                                                <div tabIndex={0} className="col-xl-6 col-sm-6 col-12 labels">
                                                                                    <label className="label-heading">
                                                                                        {settingsContent?.settings_mailing_address_text}
                                                                                    </label>
                                                                                    <label className="label-name fw-normal">
                                                                                        {caseInfo?.mailAddress}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Carrier illustration for non-BCBSAZ carriers */}
                                                                        <div className="col-5">
                                                                            <img src={accountCarrierIcon} className="mw-100" alt="carrier" />
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Tab>
                                        {Cookies.get('enableMemPreference') === 'true' && (
                                            <Tab eventKey="notification-info" title={settingsContent?.member_preference_header_label}>
                                                <MemberPreference />
                                            </Tab>
                                        )}
                                    </Tabs>
                                    <div tabIndex={0} className="mt-3 settingsnote">
                                        <p>
                                            <span className="fw-semibold">{settingsContent?.settings_note_text} </span> {settingsContent?.settings_note_content}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main> {/*st48236 - 508 compliance*/}
        </>
    )
}
export default Settings;